import { Quote } from "lucide-react";

const stats = [
  { value: "5★", label: "Customer reviews" },
  { value: "100%", label: "Owner‑operated" },
  { value: "TC", label: "Born & based" },
  { value: "All Season", label: "Spring → Fall" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 lg:py-32 bg-[#0B1C14] text-[#F4F3EF] overflow-hidden"
    >
      {/* Stripe accent bars */}
      <div className="absolute inset-y-0 left-0 w-full pointer-events-none opacity-[0.06]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(90deg, transparent 0 110px, #F4F3EF 110px 111px)",
        }}
        aria-hidden
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="font-mono-accent text-[11px] tracking-[0.25em] uppercase text-[#E64C23] mb-5">
            / About the owner
          </div>
          <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
            Run by
            <br />
            <span className="text-[#E64C23]">Christian</span>
            <br />
            Brower.
          </h2>

          <p className="mt-7 text-[#F4F3EF]/75 text-base sm:text-lg leading-relaxed max-w-md">
            Crosscut started in a single‑car garage in Traverse City with one
            mower, one trimmer, and a stubborn belief that a lawn ought to look
            like a ballpark. Years later, the standard hasn&apos;t changed — and
            you&apos;ll still see Christian on every property.
          </p>

          <div className="mt-9 inline-flex items-center gap-3 border border-[#F4F3EF]/20 px-4 py-3">
            <div className="cross-icon" aria-hidden />
            <div>
              <div className="font-mono-accent text-[10px] tracking-[0.22em] uppercase text-[#F4F3EF]/60">
                Tagline
              </div>
              <div className="font-display uppercase text-lg tracking-tight">
                You grow it… we mow it.
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 flex flex-col gap-10">
          <blockquote className="relative border-2 border-[#F4F3EF]/15 p-8 lg:p-10 bg-[#0F2418]">
            <Quote
              className="absolute -top-5 -left-5 text-[#E64C23] bg-[#0B1C14] p-1"
              size={44}
              strokeWidth={1.5}
            />
            <p className="font-display uppercase text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-[1.05]">
              &ldquo;Christian shows up when he says he&rsquo;ll show up, the
              lawn looks <span className="text-[#E64C23]">unreal</span>, and the
              edges are <span className="italic">razor straight</span>. We tip
              every week.&rdquo;
            </p>
            <div className="mt-6 font-mono-accent text-[11px] tracking-[0.22em] uppercase text-[#F4F3EF]/60">
              — A neighbor on South Creek
            </div>
          </blockquote>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#F4F3EF]/15 border-2 border-[#F4F3EF]/15">
            {stats.map((s) => (
              <div
                key={s.label}
                data-testid={`about-stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-[#0B1C14] px-5 py-7"
              >
                <div className="font-display uppercase text-3xl sm:text-4xl tracking-tight text-[#F4F3EF]">
                  {s.value}
                </div>
                <div className="mt-2 font-mono-accent text-[10px] tracking-[0.22em] uppercase text-[#F4F3EF]/60">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
